<template>
  <div class="manage-course">
    <div class="m-section-a">
      <m-level @curLevel="curLevelTap" />
      <div class="toolsb">
        <el-input class="mb-input" placeholder="请输入课程名称" v-model="mCourseName"></el-input>
        <el-button type="primary" @click="toQuery">搜索</el-button>
        <el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleAdd">新建课程</el-button>
        <p style="font-size:14px;margin: 0px 0px 0px 10px;">当前类共有 <span style="color: #20a0ff;">{{courseTotal}}</span> 个课程</p>
      </div>
      <!--课程列表-->
      <div class="course-list">
        <template v-for="(courseListItem, courseListIndex) in courseList">
          <div :key="courseListIndex" class="course-item">
            <ul class="course-item-title frc">
              <li class="course-item-title-a frc" @click="courseItemTap(courseListIndex)">
                <img src="@/assets/book01.png" alt="">
                <p class="m-text-ellipsis">{{courseListItem.courseName}}</p>
              </li>
              <li class="course-item-title-b m-text-ellipsis"><span>类别: </span><span>{{courseListItem.teachClassification? courseListItem.teachClassification.classificationName: ''}}</span></li>
              <li class="course-item-title-b m-text-ellipsis"><span>难度: </span><span>{{courseListItem.teachDifficulty?courseListItem.teachDifficulty.difficultyName:''}}</span></li>
              <li class="course-item-title-b m-text-ellipsis"><span>学分: </span><span>{{courseListItem.credits}}</span></li>
              <li v-if="courseListItem.courseState == 0" class="course-item-title-e" v-on:click="releaseCourse(courseListItem.courseId)">未发布</li>
              <li v-if="courseListItem.courseState == 2" class="course-item-title-c" v-on:click="shutoffCourse(courseListItem.courseId)">已发布</li>
              <li class="course-item-title-d frc">
                <img class="btn-icon" src="@/assets/add06.png" alt="" @click="addChapterTap(courseListIndex)" />
                <img class="btn-icon" src="@/assets/edit02.png" alt="" @click="editCourseTap(courseListIndex)" />
                <img class="btn-icon" src="@/assets/del02.png" alt="" @click="deleteCourseTap(courseListIndex)" />
              </li>
            </ul>
            <el-collapse-transition>
              <!--章节列表-->
              <ul v-show="courseListItem.expand" class="chapter-list">
                <template v-for="(chapterListItem, chapterListIndex) in courseListItem.chapterList">
                  <li :key="chapterListIndex" class="chapter-item">
                    <ul class="chapter-title frc">
                      <li class="frc">
                        <i :class="chapterListItem.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" @click="chapterItemTap(courseListIndex, chapterListIndex)"></i>
                        <img class="m-icon-check" src="@/assets/checked_false.png" alt="">
                        <p class="chapter-title-b frc" @click="chapterItemTap(courseListIndex, chapterListIndex)">
                          <span class="m-text-ellipsis">第{{chapterListIndex + 1}}章 {{chapterListItem.chapterName}}</span>
                          <span class="m-text-ellipsis">{{chapterListItem.chapterIntroduce}}</span>
                        </p>
                      </li>
                      <li class="frc operation-btn-a">
                        <img class="btn-icon" src="@/assets/add06.png" alt="" @click="addExcerptTap(courseListIndex, chapterListIndex)" />
                        <img class="btn-icon" src="@/assets/edit02.png" alt="" @click="editChapterTap(courseListIndex, chapterListIndex)" />
                        <img class="btn-icon" src="@/assets/del02.png" alt="" @click="deleteChapterTap(courseListIndex, chapterListIndex)" />
                      </li>
                    </ul>
                    <!--课时列表-->
                    <el-collapse-transition>
                      <ul v-show="chapterListItem.expand" class="chapter-content">
                        <template v-for="(excerptItem, excerptIndex) in chapterListItem.excerptList">
                          <li :key="excerptIndex" class="chapter-item">
                            <ul class="chapter-content-item frc">
                              <!--  -->
                              <li class="frc">
                                <img class="m-icon-check" v-bind:src="excerptItem.selected ? checkedTrueIcon : checkedFalseIcon" alt="" v-on:click="multipleChoiceExcerptTap(courseListIndex, chapterListIndex, excerptIndex)">
                                <span>{{excerptIndex + 1}} {{excerptItem.classesName}}</span> &nbsp; &nbsp;
                                <span style="color: #93999f">课时类型: {{excerptItem.classesType | filterClassesType}}</span>
                              </li>
                              <li class="frc operation-btn-b">
                                <img class="btn-icon" src="@/assets/edit02.png" alt="" @click="editExcerptTap(courseListIndex, chapterListIndex, excerptIndex)" />
                                <img class="btn-icon" src="@/assets/del02.png" alt="" @click="deleteExcerptTap(courseListIndex, chapterListIndex, excerptIndex)" />
                                <el-button type="text" @click="questionExcerptTap(courseListIndex, chapterListIndex, excerptIndex)">配置课时问题</el-button>
                              </li>
                            </ul>
                          </li>
                        </template>
                      </ul>
                    </el-collapse-transition>
                  </li>
                </template>
              </ul>
            </el-collapse-transition>
          </div>
        </template>
      </div>
      <div v-show="courseList.length === 0" class="nodata-a">
        <img class="no-img" src="@/assets/nodata.png" alt="">
      </div>
      <!-- 新增课程弹出层 -->
      <el-dialog :title="dialogTitleCourse == 0 ? '新增' : '编辑'" :visible.sync="dialogVisibleCourse" :close-on-click-modal="false">
        <el-form ref="mCourse" :rules="mCourseRules" :model="mCourse" label-width="100px">
          <el-form-item label="课程名称" prop="courseName">
            <el-input v-model="mCourse.courseName" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="课程描述" prop="introduce">
            <el-input v-model="mCourse.introduce" type="textarea" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="学分" prop="credits">
            <el-input v-model="mCourse.credits" type="number" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="体系" prop="architectureId">
            <el-select v-model="mCourse.architectureId" class="m-input" placeholder="请选择" clearable>
              <template v-for="(item, index) in courseLevel[0].mArray">
                <el-option :key="index" :label="item.architectureName" :value="item.architectureId" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="类别" prop="classificationId">
            <el-select v-model="mCourse.classificationId" class="m-input" placeholder="请选择" clearable>
              <template v-for="(item, index) in courseLevel[1].mArray">
                <el-option :key="index" :label="item.classificationName" :value="item.classificationId" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="难度" prop="difficultyId">
            <el-select v-model="mCourse.difficultyId" class="m-input" placeholder="请选择" clearable>
              <template v-for="(item, index) in courseLevel[2].mArray">
                <el-option :key="index" :label="item.difficultyName" :value="item.difficultyId" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图片" label-position="top">
            <el-upload class="avatar-uploader" :action="upAction" name="file" :headers="uploadHeader" :show-file-list="false" :on-success="uploadSuccess">
              <img v-if="mCourse.cover" :src="mCourse.cover | fileFilter" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetFormCourse('mCourse')">取 消</el-button>
          <el-button type="primary" @click="submitFormCourse('mCourse')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 新增章节弹出层 -->
      <el-dialog :title="dialogTitleChapter == 0 ? '新增' : '编辑'" :visible.sync="dialogVisibleChapter" :close-on-click-modal="false">
        <el-form ref="mChapter" :rules="mChapterRules" :model="mChapter" label-width="100px" label-position="top">
          <el-form-item label="章节名称" prop="chapterName">
            <el-input v-model="mChapter.chapterName" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="章节顺序" prop="order">
            <el-input v-model="mChapter.order" type="number" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="章节说明">
            <el-input v-model="mChapter.chapterIntroduce" type="textarea" placeholder="请输入" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetFormChapter('mChapter')">取 消</el-button>
          <el-button type="primary" @click="submitFormChapter('mChapter')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 新增课时弹出层 -->
      <el-dialog :title="dialogTitleExcerpt == 0 ? '新增' : '编辑'" :visible.sync="dialogVisibleExcerpt" :close-on-click-modal="false">
        <el-form ref="mExcerpt" :rules="mExcerptRules" :model="mExcerpt" label-width="100px">
          <el-form-item label="课时名称" prop="classesName">
            <el-input v-model="mExcerpt.classesName" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="类型" prop="classesType">
            <el-select v-model="mExcerpt.classesType" class="m-input" placeholder="请选择" clearable>
              <el-option label="录播课程" :value="0" />
              <el-option label="直播课程" :value="1" />
              <el-option label="线下课程" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="课时排序" prop="order">
            <el-input v-model="mExcerpt.order" type="number" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="课时视频" v-show="mExcerpt.classesType == 0">
            <el-upload class="avatar-uploader" :before-upload="beforeVideoUpload" :action="upActionVideo" name="file" :headers="uploadHeader" :show-file-list="false" :on-success="uploadSuccessVideo">
              <span v-if="mExcerpt.classesVideo">{{mExcerpt.classesVideo | fileFilter}}</span>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
          <el-form-item label="课时资料" v-show="mExcerpt.classesType !== 2">
            <el-upload class="avatar-uploader" :before-upload="beforeMaterialUpload" :action="upActionData" name="file" :headers="uploadHeader" :show-file-list="false" :on-success="uploadSuccessData">
              <span v-if="mExcerpt.materialsUrl">{{mExcerpt.materialsUrl | fileFilter}}</span>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetFormExcerpt('mExcerpt')">取 消</el-button>
          <el-button type="primary" @click="submitFormExcerpt('mExcerpt')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="配置课时问题" :visible.sync="dialogVisibleQuestion" :close-on-click-modal="false">
        <el-input v-model="content" placeholder="请输入" clearable />
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleQuestion = false">取 消</el-button>
          <el-button type="primary" @click="submitFormQuestion()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonFilters from "@/mixins/CommonFilters";
import Auth from "@/utils/Auth";
import MLevel from "@/components/MLevel";

export default {
  name: "ManageCourse",
  components: { MLevel },
  mixins: [CommonFilters],
  data () {
    return {
      checkedFalseIcon: require("@/assets/checked_false.png"),
      checkedTrueIcon: require("@/assets/checked_true.png"),
      dialogVisibleCourse: false,
      dialogTitleCourse: 0,
      dialogVisibleChapter: false,
      dialogTitleChapter: 0,
      dialogVisibleExcerpt: false,
      dialogTitleExcerpt: 0,
      dialogVisibleQuestion: false,
      mCourseName: "",
      mCourse: {},
      mChapter: {},
      mExcerpt: {},
      mCourseRules: {
        courseName: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        introduce: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        credits: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        architectureId: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        classificationId: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        difficultyId: [
          { required: true, message: "请输入", trigger: "change" }
        ]
      },
      mChapterRules: {
        chapterName: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        order: [
          { required: true, message: "请输入", trigger: "change" }
        ]
      },
      mExcerptRules: {
        classesName: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        classesType: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        order: [
          { required: true, message: "请输入", trigger: "change" }
        ]
      },
      courseList: [],
      courseListIndex: 0,
      chapterListIndex: 0,
      excerptIndex: 0,
      upAction: "",
      upActionVideo: "",
      upActionData: "",
      uploadHeader: {
        Authorization: ""
      },
      courseTotal: 0,
      multipleChoiceExcerptIds: [], // 课时 多选 ids
      professionalListData: [],

      content: "" // 课时问题
    };
  },
  computed: {
    courseLevel () {
      return this.$store.state.mlevel.courseLevel;
    },
    courseLevelIds () {
      return this.$store.state.mlevel.courseLevelIds;
    },
    userRole () {
      return this.$store.state.user.userInfo.roleKey;
    }
  },
  filters: {
    filterClassesType (type) {
      if (type === 0) {
        return "录播课程";
      } else if (type === 1) {
        return "直播课程";
      } else if (type === 2) {
        return "线下课程";
      }
    }
  },
  mounted () {
    this.upAction = process.env.VUE_APP_PREFIX + "/fastdfs/upload/image/sample";
    this.upActionVideo = process.env.VUE_APP_PREFIX + "/fastdfs/upload/file/sample";
    this.upActionData = process.env.VUE_APP_PREFIX + "/fastdfs/upload/file/sample";
    this.uploadHeader.Authorization = Auth.getToken();
    this.getCourseList(this);
  },
  methods: {
    /*
    * 课程列表
    * */
    getCourseList (that, courseName = "") { //
      that.HttpConnection.get("/course/course/usablelist", {
        params: {
          architectureId: this.courseLevelIds.architectureId,
          classificationId: this.courseLevelIds.classificationId,
          difficultyId: this.courseLevelIds.difficultyId,
          courseName: courseName
        }
      }).then(function (response) {
        if (response.rows.length > 0) {
          let _courseList = [];
          for (let item of response.rows) {
            item.expand = false;
            _courseList.push(item);
          }
          that.courseList = _courseList;
          that.courseTotal = response.total;
        } else {
          that.courseList = [];
          that.courseTotal = 0;
        }
      });
    },
    /*
    * 章节列表
    * */
    getChapterList (that, courseId, isExpand = false) {
      that.HttpConnection.get("/course/chapter/list", {
        params: {
          courseId: courseId
        }
      }).then(function (response) {
        if (response.rows.length > 0) {
          let _chapterList = [];
          for (let item of response.rows) {
            item.expand = false;
            _chapterList.push(item);
          }
          that.courseList[that.courseListIndex].chapterList = _chapterList;
          if (isExpand) {
            that.courseList[that.courseListIndex].expand = !that.courseList[that.courseListIndex].expand;
          }
          that.$forceUpdate();
        } else {
          that.courseList[that.courseListIndex].chapterList = [];
          that.courseList[that.courseListIndex].expand = false;
          that.$forceUpdate();
          that.$message({
            message: "当前无章节",
            type: "error"
          });
        }
      });
    },
    /*
    * 课时列表
    * */
    getClassList (that, chapterId, isExpand = false) {
      that.HttpConnection.get("/course/classes/list", {
        params: {
          chapterId: chapterId
        }
      }).then(function (response) {
        if (response.rows.length > 0) {
          let _classList = [];
          for (let item of response.rows) {
            item.expand = false;
            item.selected = false;
            item.excerptList = [];
            _classList.push(item);
          }
          that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].excerptList = _classList;
          if (isExpand) {
            that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].expand = !that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].expand;
          }
          that.$forceUpdate();
        } else {
          that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].excerptList = [];
          that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].expand = false;
          that.$forceUpdate();
          that.$message({
            message: "当前无课时",
            type: "error"
          });
        }
      });
    },
    /*
     * 添加 课程
     * */
    handleAdd () {
      let that = this;
      that.dialogVisibleCourse = true;
      that.dialogTitleCourse = 0;
      that.mCourse = {
        permission: 2, // 课程权限 1系统 2自建
        cover: ""
      };
      that.professionalList(that);
    },
    /*
     * 编辑 课程
     * */
    editCourseTap (courseListIndex) {
      let that = this;
      this.courseListIndex = courseListIndex;
      that.professionalList(that);
      if (this.curCourseState()) {
        return;
      }
      this.dialogVisibleCourse = true;
      this.dialogTitleCourse = 1;
      this.mCourse = { // 新增课程表单信息
        courseId: this.courseList[courseListIndex].courseId,
        courseName: this.courseList[courseListIndex].courseName, // 课程名称
        cover: this.courseList[courseListIndex].cover, // 课程封面
        introduce: this.courseList[courseListIndex].introduce, // 课程描述
        credits: this.courseList[courseListIndex].credits, // 学分
        architectureId: this.courseList[courseListIndex].architectureId, // 课程体系ID
        classificationId: this.courseList[courseListIndex].classificationId, // 课程类别ID
        difficultyId: this.courseList[courseListIndex].difficultyId, // 课程难度ID
        permission: "2" // 课程权限 1系统 2自建
      };
    },
    /*
     * 删除 课程
     * */
    deleteCourseTap (courseListIndex) {
      let that = this;
      that.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      that.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let courseId = that.courseList[courseListIndex].courseId;
        that.HttpConnection.delete("/course/course/remove/" + courseId).then(function (response) {
          that.dialogVisibleDelete = false;
          that.$message({
            message: "删除成功",
            type: "success"
          });
          that.getCourseList(that);
        });
      });
    },
    /*
     * 添加 章节
     * */
    addChapterTap (courseListIndex) {
      this.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      this.mChapter = {
        chapterName: null,
        order: 0,
        chapterIntroduce: null,
      };
      this.dialogVisibleChapter = true;
      this.dialogTitleChapter = 0;
    },
    /*
     * 编辑 章节
     * */
    editChapterTap (courseListIndex, chapterListIndex) {
      this.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      this.dialogVisibleChapter = true;
      this.dialogTitleChapter = 1;
      this.mChapter = { // 新增章节表单信息
        chapterId: this.courseList[courseListIndex].chapterList[chapterListIndex].chapterId,
        chapterName: this.courseList[courseListIndex].chapterList[chapterListIndex].chapterName,
        order: this.courseList[courseListIndex].chapterList[chapterListIndex].order,
        chapterIntroduce: this.courseList[courseListIndex].chapterList[chapterListIndex].chapterIntroduce
      };
    },
    /*
     * 删除 章节
     * */
    deleteChapterTap (courseListIndex, chapterListIndex) {
      let that = this;
      this.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      that.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let chapterId = that.courseList[courseListIndex].chapterList[chapterListIndex].chapterId;
        that.HttpConnection.delete("/course/chapter/remove/" + chapterId).then(function (response) {
          that.dialogVisibleDelete = false;
          that.$message({
            message: "删除成功",
            type: "success"
          });
          that.getChapterList(that, that.courseList[that.courseListIndex].courseId);
        });
      }).catch(() => {
        that.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    /*
     * 添加 课时
     * */
    addExcerptTap (courseListIndex, chapterListIndex) {
      this.courseListIndex = courseListIndex;
      this.chapterListIndex = chapterListIndex;
      if (this.curCourseState()) {
        return;
      }
      this.mExcerpt = { // 新增课时表单信息
        classesName: null,
        order: 0,
        materialsUrl: null,
        classesVideo: null,
        classesType: 0
      };
      this.dialogVisibleExcerpt = true;
      this.dialogTitleExcerpt = 0;
    },
    /*
     * 编辑 课时
     * */
    editExcerptTap (courseListIndex, chapterListIndex, excerptIndex) {
      this.courseListIndex = courseListIndex;
      this.chapterListIndex = chapterListIndex;
      this.excerptIndex = excerptIndex;
      if (this.curCourseState()) {
        return;
      }
      this.dialogVisibleExcerpt = true;
      this.dialogTitleExcerpt = 1;
      let _curExcerptItem = this.courseList[courseListIndex].chapterList[chapterListIndex].excerptList[excerptIndex];
      this.mExcerpt = { // 新增课时表单信息
        classesId: _curExcerptItem.classesId,
        classesName: _curExcerptItem.classesName,
        order: _curExcerptItem.order,
        materialsUrl: _curExcerptItem.materialsUrl,
        classesVideo: _curExcerptItem.classesVideo,
        classesType: _curExcerptItem.classesType
      };
    },
    /*
     * 删除 课时
     * */
    deleteExcerptTap (courseListIndex, chapterListIndex, excerptIndex) {
      let that = this;
      this.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      that.$confirm("确定要删除该条记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let _curExcerptItem = this.courseList[courseListIndex].chapterList[chapterListIndex].excerptList[excerptIndex];
        that.HttpConnection.delete("/course/classes/remove/" + _curExcerptItem.classesId).then(function (response) {
          that.dialogVisibleDelete = false;
          that.$message({
            message: "删除成功",
            type: "success"
          });
          that.getClassList(that, that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].chapterId);
        });
      });
    },
    questionExcerptTap (courseListIndex, chapterListIndex, excerptIndex) {
      this.courseListIndex = courseListIndex;
      this.chapterListIndex = chapterListIndex;
      this.excerptIndex = excerptIndex;
      let _curExcerptItem = this.courseList[courseListIndex].chapterList[chapterListIndex].excerptList[excerptIndex]
      this.content = _curExcerptItem.content;
      this.dialogVisibleQuestion = true;
    },
    /*
     * 删除 课时 多选
     * */
    multipleChoiceExcerptTap (courseListIndex, chapterListIndex, excerptIndex) {
      let that = this;
      that.courseListIndex = courseListIndex;
      if (this.curCourseState()) {
        return;
      }
      let _curExcerptItem = that.courseList[courseListIndex].chapterList[chapterListIndex].excerptList[excerptIndex];
      _curExcerptItem.selected = !_curExcerptItem.selected;
      that.$forceUpdate();
      // this.multipleChoiceExcerptIds.push(_curExcerptItem.classesId);
    },
    /*
     * 提交 新增 编辑 课程
     * */
    submitFormCourse (mCourse) {
      let that = this;
      this.$refs[mCourse].validate((valid) => {
        // eslint-disable-next-line no-empty
        if (valid) {
          console.log("add mCourse---->", this.mCourse);
          if (that.dialogTitleCourse === 0) {
            that.HttpConnection.post("/course/course/save", that.mCourse).then(function (response) {
              that.$message({
                type: "success",
                message: "新建成功!"
              });
              that.dialogVisibleCourse = false;
              that.dialogTitleCourse = 0;
              that.getCourseList(that);
            });
          } else if (that.dialogTitleCourse === 1) {
            that.HttpConnection.put("/course/course/edit", that.mCourse).then(function (response) {
              that.$message({
                type: "success",
                message: "成功!"
              });
              that.dialogVisibleCourse = false;
              that.dialogTitleCourse = 0;
              that.getCourseList(that);
            });
          }
        }
      });
    },
    /*
     * 提交 新增 编辑 章节
     * */
    submitFormChapter (mChapter) {
      let that = this;
      this.$refs[mChapter].validate((valid) => {
        if (valid) {
          that.mChapter.courseId = that.courseList[that.courseListIndex].courseId;
          console.log("add mChapter---->", this.mChapter);
          if (that.dialogTitleChapter === 0) {
            that.HttpConnection.post("/course/chapter/save", that.mChapter).then(function (response) {
              that.$message({
                type: "success",
                message: "新建成功!"
              });
              that.dialogVisibleChapter = false;
              that.dialogTitleChapter = 0;
              that.getChapterList(that, that.courseList[that.courseListIndex].courseId);
            });
          } else if (that.dialogTitleChapter === 1) {
            that.HttpConnection.put("/course/chapter/edit", that.mChapter).then(function (response) {
              that.$message({
                type: "success",
                message: "成功!"
              });
              that.dialogVisibleChapter = false;
              that.dialogTitleChapter = 0;
              that.getChapterList(that, that.courseList[that.courseListIndex].courseId);
            });
          }
        }
      });
    },
    /*
     * 提交 新增 编辑 课时
     * */
    submitFormExcerpt (mExcerpt) {
      let that = this;
      this.$refs[mExcerpt].validate((valid) => {
        // eslint-disable-next-line no-empty
        if (valid) {
          // console.log("add mExcerpt---->", this.mExcerpt);
          that.mExcerpt.chapterId = that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].chapterId;
          if (that.dialogTitleExcerpt === 0) {
            that.HttpConnection.post("/course/classes/save", that.mExcerpt).then(function (response) {
              that.$message({
                type: "success",
                message: "新建成功!"
              });
              that.dialogVisibleExcerpt = false;
              that.dialogTitleExcerpt = 0;
              that.getClassList(that, that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].chapterId);
            });
          } else if (that.dialogTitleExcerpt === 1) {
            that.HttpConnection.put("/course/classes/edit", that.mExcerpt).then(function (response) {
              that.$message({
                type: "success",
                message: "编辑成功!"
              });
              that.dialogVisibleExcerpt = false;
              that.dialogTitleExcerpt = 0;
              that.getClassList(that, that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].chapterId);
            });
          }
        }
      });
    },
    /*
   * 提交 新增 编辑 课时问题
   * */
    submitFormQuestion () {
      let that = this;
      that.HttpConnection.post("/course/question/save", {
        "courseId": that.courseList[that.courseListIndex].courseId,
        "chapterId": that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].chapterId,
        "classesId": that.courseList[that.courseListIndex].chapterList[that.chapterListIndex].excerptList[that.excerptIndex].classesId,
        "content": that.content
      }).then(function (response) {
        that.dialogVisibleQuestion = false;
        that.$message.success("保存成功");
      });
    },
    /*
     * 取消 新增 编辑 课程
     * */
    resetFormCourse (mCourse) {
      this.dialogVisibleCourse = false;
      this.$refs[mCourse].resetFields();
    },
    resetFormChapter (mChapter) {
      this.dialogVisibleChapter = false;
      this.$refs[mChapter].resetFields();
    },
    resetFormExcerpt (mExcerpt) {
      this.dialogVisibleExcerpt = false;
      this.$refs[mExcerpt].resetFields();
    },
    /*
     * 发布课程
     * */
    releaseCourse (courseId) {
      let that = this;
      that.HttpConnection.put("/course/course/release/" + courseId).then(function (response) {
        that.$message({
          type: "success",
          message: "发布成功!"
        });
        that.getCourseList(that);
      });
    },
    /*
     * 取消已发布的课程
     * */
    shutoffCourse (courseId) {
      let that = this;
      that.HttpConnection.put("/course/course/shutoff/" + courseId).then(function (response) {
        that.$message({
          type: "success",
          message: "关闭成功!"
        });
        that.getCourseList(that);
      });
    },
    curLevelTap (e) {
      this.getCourseList(this);
    },
    courseItemTap (courseListIndex) { // 显示当前课程的所有章节
      this.courseListIndex = courseListIndex;
      let chapterList = this.courseList[courseListIndex].chapterList;
      this.getChapterList(this, this.courseList[courseListIndex].courseId, true);
    },
    chapterItemTap (courseListIndex, chapterListIndex) { // 显示当前章节的所有课时
      this.courseListIndex = courseListIndex;
      this.chapterListIndex = chapterListIndex;
      this.getClassList(this, this.courseList[courseListIndex].chapterList[chapterListIndex].chapterId, true);
    },
    curCourseState () {
      let _courseState = this.courseList[this.courseListIndex].courseState;
      if (_courseState === 2) {
        this.$message({
          type: "error",
          message: "当前课程处于发布状态，不能被修改"
        });
        return true;
      }
    },
    /*
    * 专业选项
    * */
    professionalList (that) {
      that.HttpConnection.get("/professional/list", {
        params: {}
      }).then(function (response) {
        that.professionalListData = response.rows;
      });
    },
    uploadSuccess (res, file) {
      if (res.success) {
        this.$set(this.mCourse, "cover", res.filePath);
      } else {
        this.$message.error(res.message);
      }
    },
    uploadSuccessVideo (res, file) {
      if (res.success) {
        this.$set(this.mExcerpt, "classesVideo", res.filePath);
      } else {
        this.$message.error(res.message);
      }
    },
    beforeVideoUpload (file) {
      const isMP4 = file.type === "video/mp4";
      if (!isMP4) {
        this.$message.error("视频只能是 mp4 格式!");
      }
      return isMP4;
    },
    beforeManualUpload (file) {
      const isWord = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.name.endsWith("docx");
      if (!isWord) {
        this.$message.error("实验手册只能是 docx 格式!");
      }
      return isWord;
    },
    beforeMaterialUpload (file) {
      const isZipRar = file.name.endsWith("zip") || file.name.endsWith("rar");
      if (!isZipRar) {
        this.$message.error("课时资料只能上传zip或rar格式的压缩包!");
      }
      return isZipRar;
    },
    uploadSuccessData (res, file) {
      if (res.success) {
        this.$set(this.mExcerpt, "materialsUrl", res.filePath);
      } else {
        this.$message.error(res.message);
      }
    },
    toQuery () {
      this.getCourseList(this, this.mCourseName);
    },
    resetQuery () {
      this.getCourseList(this);
    }
  }
};
</script>

<style scoped lang="scss">
$bgc: #f5f7fa;
$commonColor: #20a0ff;
.manage-course {
}
.course-list {
}
.course-item {
  border: 1px solid #ebedf0;
  border-radius: 4px;
  margin-bottom: 6px;
}
.course-item-title {
  height: 50px;
  padding: 0px 20px;
  background-color: $bgc;
  .course-item-title-a {
    width: 240px;
    cursor: pointer;
    img {
      width: 16px;
      height: 18px;
      margin: 0px 10px 0px 0px;
    }
  }
  .course-item-title-b {
    width: 164px;
    margin: 0px 20px;
    font-size: 14px;
    span:nth-of-type(1) {
      color: #99a9bf;
    }
  }
  .course-item-title-c {
    padding: 4px 8px;
    background-color: #08c365;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
  .course-item-title-e {
    padding: 4px 8px;
    background-color: #bfb8b8;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
  .course-item-title-d {
    width: 80px;
    justify-content: flex-end;
  }
}
.chapter-list {
  padding: 18px 0px 18px 0px;
}
.chapter-item {
  .m-icon-check {
    width: 16px;
    height: 16px;
    margin: 0px 6px 0px 0px;
  }
  .chapter-title {
    height: 40px;
    padding: 0px 34px 0px 30px;
    justify-content: space-between;
    .chapter-title-b {
      cursor: pointer;
      span:nth-of-type(1) {
        font-size: 14px;
        font-weight: bold;
        width: 240px;
        margin: 0px 40px 0px 10px;
        color: #333;
      }
      span:nth-of-type(2) {
        width: 100px;
        color: #93999f;
        font-size: 14px;
      }
    }
  }
  .operation-btn-a {
    visibility: hidden;
  }
  .operation-btn-b {
    visibility: hidden;
  }
  .chapter-title:hover {
    background-color: #f5f7fa;
  }
  .chapter-title:hover .operation-btn-a {
    visibility: visible;
  }
  .chapter-content {
    .chapter-content-item {
      font-size: 14px;
      padding: 10px 34px 10px 70px;
      justify-content: space-between;
    }
    .chapter-content-item:hover {
      background-color: #f5f7fa;
    }
    .chapter-content-item:hover .operation-btn-b {
      visibility: visible;
    }
  }
}
.icon-tag {
  width: 20px;
  height: 20px;
  margin: 0px 6px;
}
.btn-icon {
  width: 16px;
  height: 16px;
  margin: 0px 5px;
  cursor: pointer;
}
</style>
